(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
			this.headerTransparent = this.header.querySelector('.header-transparent');
				
			if(this.headerTransparent){
				const setTopPosition = () => { 
					this.headerTopPosition = this.header.offsetHeight;
					this.header.style.marginBottom = `-${this.header.offsetHeight}px`;
				}

				// setTopPosition();
				requestAnimationFrame(setTopPosition);

				let resizeTimeout;
				window.addEventListener('resize', () => {
					clearTimeout(resizeTimeout);
					resizeTimeout = setTimeout(setTopPosition, 60);
				});

				document.body.classList.add('header-transparent-active');
      } 

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

			if (scrollTop === 0 ) {
				this.classList.add('header-at-top');
			} else {
				this.classList.remove('header-at-top');
			}		

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    const transparentHeader = document.querySelector('.header-transparent');
    if (transparentHeader) {
      const headerHeight = transparentHeader.offsetHeight;
      transparentHeader.style.marginBottom = `-${headerHeight}px`;
    }
  });

  customElements.define('sticky-header', StickyHeader);


(function () {
  // Only enable on devices with a mouse/trackpad
  if (!window.matchMedia('(hover:hover) and (pointer:fine)').matches) return;

  // Adjust to your markup; works for Dawn-like headers
  var menus = document.querySelectorAll('header-menu details, .header .header__menu details');

  menus.forEach(function (details) {
    var openTimeout, closeTimeout;
    var summary = details.querySelector('summary');

    function openMenu() {
      clearTimeout(closeTimeout);
      openTimeout = setTimeout(function () {
        if (!details.hasAttribute('open')) {
          details.setAttribute('open', '');
          if (summary) summary.setAttribute('aria-expanded', 'true');
          details.dispatchEvent(new CustomEvent('preventHeaderReveal', { bubbles: true }));
        }
      }, 80);
    }

    function closeMenu() {
      clearTimeout(openTimeout);
      closeTimeout = setTimeout(function () {
        if (details.hasAttribute('open')) {
          details.removeAttribute('open');
          if (summary) summary.setAttribute('aria-expanded', 'false');
        }
      }, 120);
    }

    details.addEventListener('mouseenter', openMenu);
    details.addEventListener('mouseleave', closeMenu);

    // Keyboard users: open on focus, close on blur-out
    details.addEventListener('focusin', function () {
      clearTimeout(closeTimeout);
      details.setAttribute('open', '');
      if (summary) summary.setAttribute('aria-expanded', 'true');
    });
    details.addEventListener('focusout', function (e) {
      if (!details.contains(e.relatedTarget)) closeMenu();
    });

    // If the <summary> has a link, prevent navigation on desktop
    var summaryLink = summary && summary.querySelector('a');
    if (summaryLink) {
      summaryLink.addEventListener('click', function (e) {
        e.preventDefault();
      });
    }
  });
})();



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["koparki-konfigurator"] && !Shopify.designMode) return;
  try {
    
(function(){
  var MODELS = {
    '16C-1':      {drive:'Diesel Stage V'},
    '19C-1':      {drive:'Diesel Stage V'},
    '19C-1 E':    {drive:'Elektryczna - bateria litowo-jonowa 48 V'},
    '19C-1 EProp':{drive:'Diesel - sterowanie elektroproporcjonalne'}
  };
  var TILE_IMGS = {}, TRACK = {url:null, w:240, dur:6.6};
  try {
    var cfgEl = document.getElementById('kopCfgData');
    if (cfgEl) {
      var cfg = JSON.parse(cfgEl.textContent) || {};
      TILE_IMGS = cfg.tiles || {};
      if (cfg.track) {
        TRACK.url = cfg.track.url || null;
        if (cfg.track.url && cfg.track.w) TRACK.w = cfg.track.w;
        if (cfg.track.dur) TRACK.dur = cfg.track.dur;
      }
    }
  } catch (err) { TILE_IMGS = {}; }

  var STANDARD_COMMON = [
    'Ogrzewana kabina ROPS/TOPS', 'Gąsienice gumowe 230 mm', 'Rozsuwane podwozie 980-1330 mm',
    'Linia hydrauliczna podwójnego działania, przełączana elektrozaworem (jedno- lub dwukierunkowa)', 'Łyżka 300 mm',
    'Ramię (dipper) 1100 mm', 'Lemiesz z poszerzeniami 980-1340 mm', 'Ledowe światła robocze',
    'Roleta przeciwsłoneczna', 'Fabryczne radio', 'Dźwignie i pedały jazdy',
    'Tuleje brązowe impregnowane grafitem', 'Wymienne tuleje konika'
  ];
  var STANDARD_EXTRA = {
    '16C-1': ['Statyczny materiałowy fotel operatora'],
    '19C-1': ['Amortyzowany materiałowy fotel operatora'],
    '19C-1 E': ['Sterowanie proporcjonalne', 'Amortyzowany materiałowy fotel operatora', 'Światła z funkcją Follow me', 'Motory jazdy z auto kick down'],
    '19C-1 EProp': ['Sterowanie elektroproporcjonalne z pokrętłami kciukowymi', 'Amortyzowany materiałowy fotel operatora', 'Światła z funkcją Follow me', 'Motory jazdy z auto kick down']
  };

  var GROUPS = [
    {id:'naped', label:'Napęd', multi:false, required:true,
     hint:'Każda maszyna ma w standardzie m.in. kabinę ROPS/TOPS, gąsienice gumowe 230 mm i łyżkę 300 mm. Pełną listę pokażemy przy dopasowanym modelu.', opts:[
      {id:'n-diesel', name:'Diesel', note:'Silnik 11,7 kW Stage V. Tankujesz i pracujesz.'},
      {id:'n-ev', name:'Elektryczny', note:'Zero emisji, cicha praca. Do budynków i stref wrażliwych.'}
    ]},
    {id:'priorytety', label:'Co jest najważniejsze w pracy', multi:true,
     hint:'Zaznacz wszystko, co dotyczy Twoich zleceń. Te wybory dobierają model.', opts:[
      {id:'p-zasieg', name:'Większy zasięg i głębokość kopania', note:'Ramię 1344 mm: zasięg 4,247 m, głębokość 2,819 m.'},
      {id:'p-sila', name:'Maksymalna siła zrywania', note:'18 kN na łyżce, ciśnienie 235 bar.'},
      {id:'p-transport', name:'Łatwy transport między budowami', note:'Najniższa masa transportowa w gamie: 1674 kg.'},
      {id:'p-praca-wewn', name:'Praca w budynkach lub strefach cichych', note:'Hale, piwnice, szpitale, praca nocna w zabudowie.'}
    ]},
    {id:'szybko', label:'Szybkozłącze', multi:false,
     hint:'Wszystkie mocowania w rodzinie 15C-19C: sworzeń 30 mm.', opts:[
      {id:'sz-brak', name:'Bez szybkozłącza', note:'Osprzęt na sworzniach, wymiana ręczna.'},
      {id:'sz-mech', name:'Mechaniczne', meta:'980/B4000 - 14 kg', note:'Opcja dla każdego modelu. Szybsza wymiana osprzętu.'},
      {id:'sz-hydr', name:'Hydrauliczne', meta:'980/B6000 - 25,5 kg', note:'Wymiana osprzętu z fotela. Wymaga dodatkowej linii hydraulicznej - dostępne w 19C-1 EProp i 19C-1 E.'}
    ]},
    {id:'osprzet', label:'Osprzęt dodatkowy', multi:true,
     hint:'Łyżka 300 mm jest w zestawie. Pełen wachlarz osprzętu do uzgodnienia z doradcą handlowym.', opts:[
      {id:'l230', name:'Łyżka 230 mm', meta:'980/B2021'},
      {id:'l450', name:'Łyżka 450 mm', meta:'980/B2024'},
      {id:'l600', name:'Łyżka 600 mm', meta:'980/B2025'},
      {id:'lskarp', name:'Łyżka skarpowa 1000 mm', meta:'980/B0108'},
      {id:'mlot', name:'Młot HM012T', meta:'980/B5211'},
      {id:'kciuk', name:'Kciuk hydrauliczny', meta:'980/T1510'},
      {id:'wiertnica', name:'Wiertnica', meta:'980/B3202 - świdry dobierane osobno'},
      {id:'tiltrotator', name:'Tiltrotator', note:'Obrót i przechył łyżki. Osprzęt dwuobwodowy - wymaga 19C-1 EProp lub 19C-1 E.'}
    ]},
    {id:'dodatki', label:'Wyposażenie opcjonalne', multi:true,
     hint:'Możesz pominąć ten krok.', opts:[
      {id:'lusterka', name:'Boczne lusterka'},
      {id:'zamki', name:'Zamki hydrauliczne na ramieniu', note:'Opcja dla 19C-1, EProp i E.'},
      {id:'alarm', name:'Alarm jazdy'},
      {id:'livelink', name:'Live Link Lite', note:'Zdalny podgląd lokalizacji, motogodzin i alarmów.'},
      {id:'wskaznik', name:'Wskaźnik przeciążenia', note:'Pilnuje stabilności przy podnoszeniu. Opcja wyłącznie dla 19C-1 EProp.'},
      {id:'regulacja', name:'Regulowanie wydajności hydrauliki', note:'Dopasowanie przepływu do osprzętu. Opcja dla 19C-1 EProp.'},
      {id:'linia-niska', name:'Dodatkowa linia hydrauliczna niskiego przepływu', note:'Opcja dla EProp i E.'}
    ]}
  ];

  var WOJ = ['dolnośląskie','kujawsko-pomorskie','lubelskie','lubuskie','łódzkie','małopolskie','mazowieckie','opolskie','podkarpackie','podlaskie','pomorskie','śląskie','świętokrzyskie','warmińsko-mazurskie','wielkopolskie','zachodniopomorskie'];

  function freshSel(){
    return {naped:null, szybko:'sz-brak', priorytety:{}, osprzet:{}, dodatki:{}};
  }
  var state = { step:0, override:null, sel:freshSel() };

  function evMode(){
    return state.sel.naped === 'n-ev';
  }

  function steps(){
    var s = GROUPS.filter(function(g){ return !g.evOnly || evMode(); })
      .map(function(g){ return {type:'group', group:g}; });
    s.push({type:'wynik'});
    return s;
  }

  function recommend(){
    var reasons = [], conflicts = [], model;
    var wantEV = evMode();
    var needEprop = !!state.sel.osprzet.tiltrotator || state.sel.szybko === 'sz-hydr' ||
                    !!state.sel.dodatki.wskaznik || !!state.sel.dodatki.regulacja || !!state.sel.dodatki['linia-niska'];
    var need19 = !!state.sel.priorytety['p-zasieg'] || !!state.sel.priorytety['p-sila'] || !!state.sel.dodatki.zamki;
    var wantLight = !!state.sel.priorytety['p-transport'];

    if(wantEV){
      model = '19C-1 E';
      if(state.sel.naped === 'n-ev') reasons.push('Wybrany napęd elektryczny - zero emisji w miejscu pracy.');
      if(state.sel.priorytety['p-praca-wewn']) reasons.push('Praca w budynkach i strefach cichych - tu wersja elektryczna nie ma konkurencji.');
      if(state.sel.osprzet.tiltrotator) reasons.push('Tiltrotator (osprzęt dwuobwodowy) - 19C-1 E ma sterowanie proporcjonalne i dwa obwody pomocnicze.');
      if(state.sel.szybko === 'sz-hydr') reasons.push('Szybkozłącze hydrauliczne z dodatkową linią - dostępne w EProp i E.');
      if(state.sel.priorytety['p-zasieg']) reasons.push('Ramię 1344 mm jest dostępne w rodzinie 19C-1.');
    } else if(needEprop){
      model = '19C-1 EProp';
      if(state.sel.osprzet.tiltrotator) reasons.push('Tiltrotator (osprzęt dwuobwodowy) wymaga sterowania elektroproporcjonalnego - to specjalność EProp.');
      if(state.sel.szybko === 'sz-hydr') reasons.push('Szybkozłącze hydrauliczne z dodatkową linią - opcja dla EProp i E.');
      if(state.sel.dodatki.wskaznik) reasons.push('Wskaźnik przeciążenia - opcja wyłącznie dla 19C-1 EProp.');
      if(state.sel.dodatki.regulacja) reasons.push('Regulowanie wydajności hydrauliki - opcja wyłącznie dla 19C-1 EProp.');
      if(state.sel.dodatki['linia-niska']) reasons.push('Dodatkowa linia niskiego przepływu - opcja dla EProp i E.');
      if(state.sel.priorytety['p-zasieg']) reasons.push('Ramię 1344 mm - dostępne w rodzinie 19C-1.');
      if(state.sel.priorytety['p-sila']) reasons.push('Siła zrywania 18 kN na łyżce i ciśnienie 235 bar.');
    } else if(need19){
      model = '19C-1';
      if(state.sel.priorytety['p-zasieg']) reasons.push('Ramię 1344 mm: zasięg 4,247 m i głębokość 2,819 m - opcja rodziny 19C-1.');
      if(state.sel.priorytety['p-sila']) reasons.push('Najwyższa siła zrywania w gamie: 18 kN na łyżce, 235 bar.');
      if(state.sel.dodatki.zamki) reasons.push('Zamki hydrauliczne na ramieniu - opcja od 19C-1 wzwyż.');
    } else if(wantLight){
      model = '16C-1';
      reasons.push('Najniższa masa transportowa w gamie: 1674 kg - najprostszy transport między budowami.');
      reasons.push('Ten sam silnik, zasięg i głębokość kopania co w 19C-1.');
    } else {
      model = '19C-1';
      reasons.push('Najbardziej uniwersalny model gamy: 18 kN siły zrywania, sterowanie proporcjonalne i amortyzowany fotel w standardzie.');
      reasons.push('Doradca potwierdzi dobór po rozmowie o charakterze prac.');
    }

    if(wantLight && model !== '16C-1'){
      conflicts.push('Zaznaczono łatwy transport, ale pozostałe wymagania wskazują na rodzinę 19C-1 - masa robocza od 1910 kg wobec 1749 kg w 16C-1. Doradca pomoże wyważyć te dwa priorytety.');
    }
    if(state.sel.naped === 'n-diesel' && state.sel.priorytety['p-praca-wewn']){
      conflicts.push('Praca w budynkach i strefach cichych zwykle przemawia za wersją elektryczną 19C-1 E - warto omówić to z doradcą.');
    }
    return {model:model, reasons:reasons, conflicts:conflicts};
  }

  function finalModel(reco){ return state.override || reco.model; }

  function overrideConflicts(model){
    var c = [];
    var eprops = ['19C-1 E','19C-1 EProp'];
    if(eprops.indexOf(model) < 0){
      if(state.sel.osprzet.tiltrotator) c.push('Tiltrotator to osprzęt dwuobwodowy - wymaga 19C-1 EProp lub 19C-1 E.');
      if(state.sel.szybko === 'sz-hydr') c.push('Szybkozłącze hydrauliczne - dostępne w 19C-1 EProp i 19C-1 E.');
      if(state.sel.dodatki.wskaznik) c.push('Wskaźnik przeciążenia to opcja wyłącznie dla 19C-1 EProp.');
      if(state.sel.dodatki['linia-niska']) c.push('Dodatkowa linia niskiego przepływu to opcja dla EProp i E.');
    }
    if(model === '19C-1 E' && state.sel.dodatki.wskaznik){
      c.push('Wskaźnik przeciążenia nie występuje w 19C-1 E - to opcja dla 19C-1 EProp.');
    }
    if(model !== '19C-1 EProp' && state.sel.dodatki.regulacja){
      c.push('Regulowanie wydajności hydrauliki to opcja wyłącznie dla 19C-1 EProp.');
    }
    if(model === '16C-1'){
      if(state.sel.priorytety['p-zasieg']) c.push('Ramię 1344 mm nie jest dostępne w 16C-1.');
      if(state.sel.dodatki.zamki) c.push('Zamki hydrauliczne na ramieniu to opcja od 19C-1 wzwyż.');
    }
    if(model !== '19C-1 E' && state.sel.naped === 'n-ev'){
      c.push('Wybrano napęd elektryczny - jedyna elektryczna maszyna w gamie to 19C-1 E.');
    }
    if(model === '19C-1 E' && state.sel.naped === 'n-diesel'){
      c.push('Wybrano napęd Diesel, a 19C-1 E jest maszyną elektryczną.');
    }
    return c;
  }

  var CHECK = '<svg viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="M2 6.5L4.8 9.2 10 3.4" stroke="#1D1D1F" stroke-width="2.1" stroke-linecap="square"/></svg>';

  function esc(s){ return String(s).replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }

  var TRACK_TEX = ['https://cdn.shopify.com/s/files/1/1036/2611/3373/files/left_to_right.webp?v=1786011879','https://cdn.shopify.com/s/files/1/1036/2611/3373/files/right_to_left.webp?v=1786011879'];

  function trackHtml(model){
    var style = '--kop-track-dur:' + TRACK.dur + 's;';
    var cls = 'kop-track';
    if(TRACK.url){
      cls += ' kop-track--img';
      style += '--kop-track-img:url(' + TRACK.url.replace(/[()'"\s]/g, encodeURIComponent) + ');--kop-track-w:' + TRACK.w + 'px;';
    } else {
      var order = Object.keys(MODELS);
      var idx = order.indexOf(model);
      if(idx < 0){ idx = 0; }
      style += '--kop-track-img:url(' + TRACK_TEX[idx % 2] + ');';
      if(idx % 2 === 0){ cls += ' kop-track--rev'; }
      style += '--kop-track-w:' + TRACK.w + 'px;';
    }
    return '<span class="' + cls + '" style="' + style + '" aria-hidden="true"></span>';
  }

  function groupHtml(g){
    var std = '';
    var opts = g.opts.map(function(o){
      var on = g.multi ? !!state.sel[g.id][o.id] : state.sel[g.id] === o.id;
      return '<button type="button" class="kop-opt" data-multi="' + (g.multi?1:0) + '" data-g="' + g.id + '" data-o="' + o.id + '"' +
        ' aria-pressed="' + (on ? 'true':'false') + '">' +
        '<span class="kop-mark">' + CHECK + '</span>' +
        '<span style="flex:1;min-width:0">' +
          '<span class="kop-opt__name">' + esc(o.name) + '</span>' +
          (o.meta ? '<span class="kop-opt__meta">' + esc(o.meta) + '</span>' : '') +
          (o.note ? '<span class="kop-opt__note">' + esc(o.note) + '</span>' : '') +
          (o.flag ? '<span class="kop-flag">' + esc(o.flag) + '</span>' : '') +
        '</span></button>';
    }).join('');
    return '<div class="kop-grp"><div class="kop-grp__label">' + esc(g.label) +
      (g.multi ? '<span class="kop-tag">wielokrotny</span>' : '') + '</div>' +
      (g.hint ? '<div class="kop-grp__hint">' + esc(g.hint) + '</div>' : '') + std +
      '<div class="kop-opts">' + opts + '</div></div>';
  }

  function resultHtml(){
    var reco = recommend();
    var model = finalModel(reco);
    var isOverridden = !!state.override && state.override !== reco.model;
    var conf = isOverridden ? overrideConflicts(model) : reco.conflicts;

    var html = '<div class="kop-reco">' +
      '<span class="kop-reco__badge">' + (isOverridden ? 'Twój wybór' : 'Dopasowany model') + '</span>' +
      '<div class="kop-reco__model">' + esc(model) + '</div>' +
      '<div class="kop-reco__drive">' + esc(MODELS[model].drive) + '</div>';
    if(!isOverridden){
      html += '<ul class="kop-reco__why">' + reco.reasons.map(function(x){ return '<li>' + esc(x) + '</li>'; }).join('') + '</ul>';
    }
    conf.forEach(function(c){ html += '<div class="kop-reco__conflict">' + esc(c) + '</div>'; });
    html += '</div>';

    var stdList = STANDARD_COMMON.concat(STANDARD_EXTRA[model] || []);
    html += '<div class="kop-stdpanel"><div class="kop-stdpanel__title">W standardzie ' + esc(model) + '</div><ul class="kop-stdpanel__list">' +
      stdList.map(function(x){ return '<li>' + esc(x) + '</li>'; }).join('') + '</ul></div>';

    html += '<p class="kop-alt__hintline">Znasz gamę i wolisz inny model? Kliknij poniżej - reszta konfiguracji zostaje.</p><div class="kop-alt">';
    Object.keys(MODELS).forEach(function(code){
      var img = TILE_IMGS[code];
      var selected = code === model;
      html += '<button type="button" class="kop-alt__tile" data-alt="' + esc(code) + '" aria-pressed="' + (selected ? 'true':'false') + '">' +
        (img ? '<img class="kop-alt__img" loading="lazy" src="' + esc(img) + '" alt="Minikoparka JCB ' + esc(code) + '">' : '') +
        trackHtml(code) +
        '<span class="kop-alt__code">' + esc(code) + '</span>' +
        '<span class="kop-alt__drive">' + esc(MODELS[code].drive) + '</span></button>';
    });
    html += '</div>';

    html += '<div class="kop-plate"><div class="kop-plate__title">Specyfikacja zapytania</div><dl class="kop-rows" id="kopPlate"></dl></div>';
    html += '<button type="button" class="kop-restart" id="kopRestart">Zacznij od nowa - wyczyść odpowiedzi i wróć na początek</button>';
    return {html:html, reco:reco, model:model, conflicts:conf, overridden:isOverridden};
  }

  function labelOf(gid, oid){
    for(var i=0;i<GROUPS.length;i++){
      if(GROUPS[i].id!==gid) continue;
      for(var j=0;j<GROUPS[i].opts.length;j++) if(GROUPS[i].opts[j].id===oid) return GROUPS[i].opts[j].name;
    }
    return oid;
  }
  function keys(obj){ var a=[],k; for(k in obj) if(obj[k]) a.push(k); return a; }

  function fillPlateAndBody(res){
    var rows = [
      ['Model', res.model + (res.overridden ? ' (wybór klienta; sugestia: ' + res.reco.model + ')' : ' (dopasowany)')],
      ['Napęd', state.sel.naped ? labelOf('naped', state.sel.naped) : null],
      ['Priorytety', keys(state.sel.priorytety).map(function(id){return labelOf('priorytety',id);}).join(', ') || null],
      ['Wyposażenie std.', (STANDARD_EXTRA[res.model] || []).join(', ') + ' + wspólny standard gamy (' + STANDARD_COMMON.length + ' pozycji)'],
      ['Szybkozłącze', labelOf('szybko', state.sel.szybko)]
    ];
    var osp = keys(state.sel.osprzet).map(function(id){return labelOf('osprzet',id);});
    rows.push(['Osprzęt', osp.length ? osp.join(', ') : null]);
    var dod = keys(state.sel.dodatki).map(function(id){return labelOf('dodatki',id);});
    rows.push(['Opcje', dod.length ? dod.join(', ') : null]);
    if(evMode()){
      rows.push(['Ładowanie', 'Bateria 19,8 kWh; wbudowane 230 V ok. 5 h / 110 V ok. 10,5 h; ładowarka szybka 415 V ok. 2,5 h']);
    }

    var plate = document.getElementById('kopPlate');
    if(plate){
      plate.innerHTML = rows.map(function(row){
        return '<div class="kop-row"><dt>' + esc(row[0]) + '</dt><dd class="' + (row[1]?'':'kop-empty') + '">' + esc(row[1] || 'nie wybrano') + '</dd></div>';
      }).join('');
    }

    var body = 'ZAPYTANIE Z KONFIGURATORA MINIKOPAREK JCB\n' +
      '-----------------------------------------\n' +
      rows.map(function(row){ return row[0] + ': ' + (row[1] || '-'); }).join('\n');
    body += '\n\nWYPOSAŻENIE STANDARDOWE (' + res.model + '):\n' +
      STANDARD_COMMON.concat(STANDARD_EXTRA[res.model] || []).map(function(x){ return '- ' + x; }).join('\n');
    if(res.reco.reasons.length){
      body += '\n\nUZASADNIENIE DOPASOWANIA:\n' + res.reco.reasons.map(function(x){ return '- ' + x; }).join('\n');
    }
    if(res.conflicts.length){
      body += '\n\nUWAGI DO OMÓWIENIA:\n' + res.conflicts.map(function(x){ return '- ' + x; }).join('\n');
    }
    var msgEl = document.getElementById('kop-msg');
    var msg = msgEl && msgEl.value ? msgEl.value.trim() : '';
    if(msg){
      body = 'WIADOMOŚĆ OD KLIENTA:\n' + msg + '\n\n' + body;
    }
    var el = document.getElementById('kopBody');
    if(el) el.value = body;
  }

  function render(scroll){
    var all = steps();
    if(state.step >= all.length) state.step = all.length - 1;
    var cur = all[state.step];
    var total = all.length;
    var stepEl = document.getElementById('kopStep');
    var info = document.getElementById('kopStepInfo');
    var bar = document.getElementById('kopBarFill');
    var back = document.getElementById('kopBack');
    var next = document.getElementById('kopNext');

    if(cur.type === 'group'){
      stepEl.innerHTML = groupHtml(cur.group);
      info.textContent = 'Krok ' + (state.step + 1) + ' z ' + total + ' - ' + cur.group.label;
      var empty = cur.group.multi ? keys(state.sel[cur.group.id]).length === 0 : !state.sel[cur.group.id];
      next.hidden = false;
      next.disabled = !!cur.group.required && !state.sel[cur.group.id];
      next.textContent = (cur.group.multi && empty) ? 'Pomiń' : 'Dalej';
    } else {
      var res = resultHtml();
      stepEl.innerHTML = res.html;
      fillPlateAndBody(res);
      info.textContent = 'Krok ' + total + ' z ' + total + ' - Twój wynik';
      next.hidden = false;
      next.disabled = false;
      next.textContent = 'Wyślij zapytanie do doradcy';
    }

    bar.style.width = Math.round(((state.step + 1) / total) * 100) + '%';
    back.hidden = state.step === 0;

    if(scroll){
      var quiz = document.querySelector('.kop-quiz');
      if(quiz && quiz.getBoundingClientRect().top < 0){
        quiz.scrollIntoView({behavior:'smooth', block:'start'});
      }
    }
  }

  document.addEventListener('click', function(e){
    if(e.target && e.target.id === 'kopRestart'){
      state.sel = freshSel();
      state.override = null;
      state.step = 0;
      render(true);
      return;
    }
    var alt = e.target.closest ? e.target.closest('.kop-alt__tile') : null;
    if(alt){
      // Nad siatka kafli stoi blok o zmiennej wysokosci (lista "dlaczego ten model"
      // znika przy recznym wyborze, pojawiaja sie konflikty). Przebudowa innerHTML
      // przesuwala siatke spod palca - skok strony na mobile. Kotwiczymy siatke:
      // mierzymy jej pozycje przed i po renderze i korygujemy scroll o roznice.
      var grid = document.querySelector('.kop-alt');
      var anchorTop = grid ? grid.getBoundingClientRect().top : null;
      var code = alt.getAttribute('data-alt');
      var reco = recommend();
      state.override = (code === reco.model) ? null : code;
      render(false);
      if(anchorTop !== null){
        var grid2 = document.querySelector('.kop-alt');
        if(grid2){
          var delta = grid2.getBoundingClientRect().top - anchorTop;
          if(delta){
            try { window.scrollBy({top: delta, left: 0, behavior: 'instant'}); }
            catch(err){ window.scrollBy(0, delta); }
          }
        }
      }
      return;
    }
    var ob = e.target.closest ? e.target.closest('.kop-opt') : null;
    if(ob){
      var g = ob.getAttribute('data-g'), o = ob.getAttribute('data-o'), multi = ob.getAttribute('data-multi') === '1';
      if(multi){ state.sel[g][o] = !state.sel[g][o]; }
      else { state.sel[g] = state.sel[g] === o ? null : o; }
      state.override = null;
      render(false);
      return;
    }
    if(e.target && e.target.id === 'kopBack'){
      if(state.step > 0){ state.step -= 1; render(true); }
      return;
    }
    if(e.target && e.target.id === 'kopNext'){
      var all = steps();
      if(state.step < all.length - 1){
        state.step += 1; render(true);
      } else {
        var f = document.getElementById('kop-formularz');
        if(f) f.scrollIntoView({behavior:'smooth', block:'start'});
      }
      return;
    }
  });

  var woj = document.getElementById('kop-woj');
  if(woj){
    WOJ.forEach(function(w){
      var op = document.createElement('option'); op.textContent = w; woj.appendChild(op);
    });
  }

  var sticky = document.getElementById('kopSticky');
  var cfgSec = document.getElementById('kop-konfigurator');
  if(sticky && cfgSec && 'IntersectionObserver' in window){
    // Pasek widoczny na CALEJ stronie. Znika tylko, gdy na ekranie jest sekcja
    // konfiguratora (formularz jest w jej wnetrzu) albo stopka sklepu.
    // Jedna granica na sekcje - bez obserwatora formularza z rootMargin,
    // ktory pstrykal przy kazdej zmianie wysokosci quizu (przyczyna migania).
    // Czatu NIE dotykamy w ogole.
    var inCfg = false, inFooter = false;
    function syncSticky(){
      sticky.hidden = inCfg || inFooter;
    }

    var ioCfg = new IntersectionObserver(function(entries){
      inCfg = entries[0].isIntersecting;
      syncSticky();
    }, {threshold: 0});
    ioCfg.observe(cfgSec);

    var footEl = document.querySelector('footer');
    if(footEl){
      var ioFoot = new IntersectionObserver(function(entries){
        inFooter = entries[0].isIntersecting;
        syncSticky();
      }, {threshold: 0});
      ioFoot.observe(footEl);
    }
    syncSticky();
  }

  var form = document.getElementById('kopLeadForm');
  if(form){
    form.addEventListener('submit', function(){
      var res = resultHtml();
      fillPlateAndBody(res);
    });
  }

  render(false);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["koparki-modele"] && !Shopify.designMode) return;
  try {
    
(function(){
  var wraps = document.querySelectorAll('[data-mvid]');
  if (!wraps.length) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function play(w){
    var v = w.querySelector('video');
    if (!v) return;
    if (v.preload === 'none') { v.preload = 'auto'; v.load(); }
    v.muted = true; v.defaultMuted = true;
    var p = v.play();
    if (p && p.catch) { p.catch(function(){}); }
  }
  function stop(w){
    var v = w.querySelector('video');
    if (v && !v.paused) { v.pause(); }
  }


  if (reduce || !('IntersectionObserver' in window)) return;

  // rozgrzewka: zaczynamy sciagac plik 600 px przed wejsciem w kadr
  var warm = new IntersectionObserver(function(entries){
    for (var a=0;a<entries.length;a++){
      if (!entries[a].isIntersecting) continue;
      var v = entries[a].target.querySelector('video');
      if (v && v.preload !== 'auto') { v.preload = 'auto'; v.load(); }
      warm.unobserve(entries[a].target);
    }
  }, {rootMargin:'600px 0px'});

  var io = new IntersectionObserver(function(entries){
    for (var k=0;k<entries.length;k++){
      if (entries[k].isIntersecting && entries[k].intersectionRatio >= 0.35) { play(entries[k].target); }
      else { stop(entries[k].target); }
    }
  }, {threshold:[0, 0.35, 0.8]});

  for (var j=0;j<wraps.length;j++){ warm.observe(wraps[j]); io.observe(wraps[j]); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["koparki-osprzet"] && !Shopify.designMode) return;
  try {
    
(function(){
  var rail = document.getElementById('kopRail');
  if(!rail) return;
  var root = document.getElementById('kop-osprzet');
  var prev = root.querySelector('[data-rail="prev"]');
  var next = root.querySelector('[data-rail="next"]');

  function step(){
    var card = rail.querySelector('.kop-card');
    var w = card ? card.getBoundingClientRect().width : rail.clientWidth * 0.6;
    return Math.max(160, Math.round(w + 14));
  }
  var counter = document.getElementById('kopRailCount');
  function sync(){
    if (counter) {
      var cards = rail.querySelectorAll('.kop-card');
      if (cards.length) {
        var idx = Math.round(rail.scrollLeft / step()) + 1;
        if (idx < 1) { idx = 1; }
        if (idx > cards.length) { idx = cards.length; }
        counter.textContent = idx + ' / ' + cards.length;
      }
    }
    if(!prev || !next) return;
    var max = rail.scrollWidth - rail.clientWidth - 2;
    prev.disabled = rail.scrollLeft <= 2;
    next.disabled = rail.scrollLeft >= max;
  }
  if(prev) prev.addEventListener('click', function(){ rail.scrollLeft -= step(); });
  if(next) next.addEventListener('click', function(){ rail.scrollLeft += step(); });
  rail.addEventListener('scroll', sync, {passive:true});
  window.addEventListener('resize', sync);
  rail.addEventListener('keydown', function(e){
    if(e.key === 'ArrowRight'){ rail.scrollLeft += step(); e.preventDefault(); }
    if(e.key === 'ArrowLeft'){ rail.scrollLeft -= step(); e.preventDefault(); }
  });
  sync();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["koparki-zasiegi"] && !Shopify.designMode) return;
  try {
    
(function(){
  var GEO_1100 = {A:'4,043 m',B:'3,981 m',C:'2,576 / 2,421 m',D:'3,667 m',E:'2,637 m',F:'3,154 m',G:'2,139 m',H:'1,517 / 1,196 m',I:'75 st.',J:'55 st.',lyz:'201 st.',ram:'126 st.',obr:'7,9 obr/min'};
  var GEO_1344 = {A:'4,247 m',B:'4,22 m',C:'2,819 / 2,665 m',D:'3,847 m',E:'2,818 m',F:'3,335 m',G:'2,375 m',H:'1,565 / 1,236 m',I:'75 st.',J:'55 st.',lyz:'201 st.',ram:'126 st.',obr:'7,9 obr/min'};

  function variant(model, dip){
    var geo = (dip === '1344') ? GEO_1344 : GEO_1100;
    var out = {};
    for (var k in geo) out[k] = geo[k];
    if (model === '16C-1') { out.sL = '15,6 kN'; out.sD = '7,9 kN'; }
    else { out.sL = '18 kN'; out.sD = (dip === '1344') ? '7,9 kN' : '9,1 kN'; }
    return out;
  }

  var DIMS = {
    '16C-1':      {wA:'1,218 m', wB:'1,22 m', wC:'1,578 m', wD:'0,409 m', wE:'1,103 m', wF:'0,996 m', wG:'2,324 m', wH:'0,162 m', wI:'0,75 - 1,11 m', wJ:'0,98 / 1,33 m', wK:'3,86 m', wL:'0,367 m', wM:'0,434 m'},
    '19C-1':      {wA:'1,218 m', wB:'1,22 m', wC:'1,578 m', wD:'0,409 m', wE:'1,103 m', wF:'0,996 m', wG:'2,328 m', wH:'0,162 m', wI:'0,75 - 1,11 m', wJ:'0,98 / 1,33 m', wK:'3,86 m', wL:'0,367 m', wM:'0,434 m'},
    '19C-1 EProp':{wA:'1,218 m', wB:'1,22 m', wC:'1,578 m', wD:'0,409 m', wE:'1,103 m', wF:'0,996 m', wG:'2,328 m', wH:'0,162 m', wI:'0,75 - 1,11 m', wJ:'0,98 / 1,33 m', wK:'3,862 m', wL:'0,367 m', wM:'0,434 m'},
    '19C-1 E':    {wA:'1,218 m', wB:'1,22 m', wC:'1,578 m', wD:'0,409 m', wE:'1,103 m', wF:'0,996 m', wG:'2,345 m', wH:'0,162 m', wI:'0,75 - 1,10 m', wJ:'0,98 / 1,33 m', wK:'3,86 m', wL:'0,367 m', wM:'0,434 m'}
  };

  var cur = { model: '19C-1', dip: '1100', key: null };
  var root = document.getElementById('kop-zasiegi');
  if (!root) return;

  function effDip(){
    return (cur.model === '16C-1' && cur.dip === '1344') ? '1100' : cur.dip;
  }

  function apply(){
    var dip = effDip();
    var note = document.getElementById('kopZNote');
    if (note) note.hidden = !(cur.model === '16C-1' && cur.dip === '1344');

    var v = variant(cur.model, dip);
    var dims = DIMS[cur.model] || {};
    for (var dk in dims) v[dk] = dims[dk];
    var spans = root.querySelectorAll('[data-k]');
    for (var i = 0; i < spans.length; i++) {
      var k = spans[i].getAttribute('data-k');
      if (v[k]) spans[i].textContent = v[k];
    }
    var pills = root.querySelectorAll('.kop-pill');
    for (var j = 0; j < pills.length; j++) {
      var p = pills[j];
      if (p.hasAttribute('data-zmodel')) p.classList.toggle('is-on', p.getAttribute('data-zmodel') === cur.model);
      if (p.hasAttribute('data-zdip')) p.classList.toggle('is-on', p.getAttribute('data-zdip') === dip);
    }
  }

  function highlight(){
    var hss = root.querySelectorAll('[data-hs]');
    for (var i = 0; i < hss.length; i++) {
      hss[i].classList.toggle('is-on', hss[i].getAttribute('data-hs') === cur.key);
    }
    var lines = root.querySelectorAll('[data-line]');
    for (var j = 0; j < lines.length; j++) {
      lines[j].classList.toggle('is-on', lines[j].getAttribute('data-line') === cur.key);
    }
    var stages = root.querySelectorAll('.kop-fig__stage');
    for (var q = 0; q < stages.length; q++) {
      var show = false;
      if (cur.key) {
        show = !!stages[q].querySelector('.kop-hs[data-hs="' + cur.key + '"]');
      }
      stages[q].classList.toggle('is-shown', show);
    }
  }

  root.addEventListener('click', function(e){
    var pill = e.target.closest ? e.target.closest('.kop-pill') : null;
    if (pill) {
      if (pill.hasAttribute('data-zmodel')) cur.model = pill.getAttribute('data-zmodel');
      if (pill.hasAttribute('data-zdip')) cur.dip = pill.getAttribute('data-zdip');
      apply();
      return;
    }
    var hs = e.target.closest ? e.target.closest('[data-hs]') : null;
    if (hs) {
      var k = hs.getAttribute('data-hs');
      cur.key = (cur.key === k) ? null : k;
      highlight();
    }
  });

  apply();
})();

  } catch(e) { console.error(e); }
})();
})();
